import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BrandButton } from './ui-kit/BrandButton';
import { Reveal } from './ui-kit/Reveal';
import BrandAgentJourney from './BrandAgentJourney';

const Hero = () => {
  const { t } = useLanguage();

  const trackPrimaryClick = () => {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'ViewContent', { content_name: 'Hero Primary CTA' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative bg-bg pt-20 md:pt-32 pb-12 md:pb-20 overflow-hidden"
    >
      <div className="container-page grid md:grid-cols-12 gap-8 md:gap-12 items-center">
        <div className="md:col-span-6 lg:col-span-6 order-1 min-w-0">
          <Reveal>
            <span className="eyebrow text-ink-muted">{t.hero.eyebrow}</span>
          </Reveal>

          <Reveal delay={80}>
            <h1 className="mt-5 md:mt-6 text-hero text-ink">{t.hero.title}</h1>
          </Reveal>

          <Reveal delay={140}>
            <p className="mt-4 md:mt-6 text-body-lg text-ink-muted max-w-xl">{t.hero.subtitle}</p>
          </Reveal>

          <Reveal delay={200}>
            <div className="mt-6 md:mt-8 flex flex-wrap gap-3">
              <BrandButton
                to="/yhteys?interest=brand-agent#contact-form"
                variant="primary"
                size="lg"
                onClick={trackPrimaryClick}
                iconRight={ArrowRight}
                data-testid="hero-cta-primary-btn"
                className="shadow-[0_8px_24px_rgba(47,111,94,0.18)]"
              >
                {t.hero.primaryCta}
              </BrandButton>
              <BrandButton href="#brandiagentti" variant="secondary" size="lg" data-testid="hero-cta-secondary-btn">
                {t.hero.secondaryCta}
              </BrandButton>
            </div>
          </Reveal>

          <Reveal delay={260}>
            <ul className="mt-8 md:mt-10 flex flex-col sm:flex-row sm:flex-wrap gap-x-6 gap-y-2 text-[13.5px] text-ink-muted">
              {t.hero.trust.map((line) => (
                <li key={line} className="flex items-center gap-2">
                  <Check className="w-3.5 h-3.5 text-brand" strokeWidth={2.5} />
                  <span>{line}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        {/* Right visual: brand-agent journey animation (replaces old ChatMockup) */}
        <div className="md:col-span-6 lg:col-span-6 order-2 mt-2 md:mt-0 min-w-0">
          <Reveal delay={120}>
            <BrandAgentJourney contactHref="/yhteys?interest=brand-agent#contact-form" />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;
